import { type EnvironmentId, type ThreadId } from "@t3tools/contracts";
import { Trans } from "@lingui/react/macro";
import { BotIcon } from "lucide-react";
import { scopeThreadRef } from "@t3tools/client-runtime";

import { Button } from "../ui/button";
import { openSubAgentList } from "../../subAgentPanelStore";

export function SubAgentsHeaderButton({
  environmentId,
  threadId,
}: {
  environmentId: EnvironmentId;
  threadId: ThreadId;
}) {
  return (
    <Button
      variant="outline"
      size="xs"
      className="shrink-0 gap-1"
      onClick={() => openSubAgentList(scopeThreadRef(environmentId, threadId))}
    >
      <BotIcon className="size-3" />
      <Trans>Agents</Trans>
    </Button>
  );
}
